import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Link } from "react-router-dom";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    { Header: "ชื่อผู้ใช้งาน", accessor: "username" },
    { Header: "ชื่อ-นามสกุล", accessor: "name" },
    { Header: "สิทธิ์การเข้าถึง", accessor: "role" },
    { Header: "สถานะ", accessor: "status" },
    // { Header: "อนุมัติ", accessor: "approved" },
    {
      Header: "อนุมัติ",
      accessor: "user_approved",
      disableSortBy: true,
      Cell: ({ row }) => <div></div>,
    },
  ];

  return columns;
};

export default useColumns;
